import { ACCESS_EMBEDDED_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"

function SingleCTASection() {
  const { getAsset } = usePageAssets()
  const background = getAsset("single-cta-preset-background")
  return (
    <Container section>
      <CTA
        background={background}
        label="Get Started"
        title="Try Preset’s embedded dashboards today."
        description="Get in touch with our team to ask questions and pilot our embedded solution for your external applications."
        linkText="Request Access"
        linkUrl={ACCESS_EMBEDDED_URL}
        trackClick="Request Access (cta)_Use Cases - Customer Apps"
        size="wide"
        dark
      />
    </Container>
  )
}

export default SingleCTASection
